import React, { Component, Fragment } from "react";
import api from "../../../../services/api";
import SelectMeta from "../SelectMeta/index";
import { Link } from "react-router-dom";
import NomeUnidade from "../../../UI/NomeUnidade";
import utils from "../SelectMeta/utils";

export default class FormMeta extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Form Meta",
            cursos: this.props.cursos,
            cursoSelecionado: this.props.cursoSelecionado,
            cr: ""
        }

    }

    onSubmit = async (event) => {
        event.preventDefault();

        try {

            let { codigo, unidade, modalidade, curso, cargaHoraria, CR } = event.target;
            let cadastro = {
                codigo: codigo.value,
                unidade: unidade.value,
                modalidade: modalidade.value.split(",")[0],
                curso: curso.value,
                cargaHoraria: cargaHoraria.value,
                CR: CR.value
            }

            let status = await api.post("/novocurso", cadastro)
            if(status.data.status === "ok") {
                window.showNotification('Cadastrado com sucesso', 'success');
                event.target.reset();
            }
            else window.showNotification(status.data.status || 'Erro ao cadastrar', 'danger');

        } catch (erro) {
            alert("Erro ao cadastrar", erro);
        }
    }

    selectModalidade = (event) => {
        let cr = utils.modalidades.filter(modalidade => modalidade.modalidade === event.target.value);
        //let cr = event.target.value.split(",");
        this.setState({ cr: cr[0].cr });
    }

    render() {
        return (
            <Fragment>
                <NomeUnidade unidade={this.props.location.unidade}/>
                <div className="content">
                    <div className="row">
                        <div className="col-md-8 ml-auto mr-auto">
                            <div className="card card-user">
                                <div className="card-header">
                                    <h5 className="card-title">Cadastrar novo curso</h5>
                                    <Link to={location => ({ ...location, pathname: (this.props.location && this.props.location.anterior) || "/unidade" })}>
                                        <button className="btn" style={{float: "right"}}>Voltar</button>
                                    </Link>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.onSubmit} className="gap" id="cadastrocurso">

                                        <SelectMeta 
                                            selectModalidade={this.selectModalidade} 
                                            label={<label htmlFor="modalidade">Modalidade:</label>}
                                            visible={<option hidden>Selecione uma modalidade</option>}
                                        />

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="curso">Curso</label>
                                                    <input type="text" className="form-control" placeholder="Curso" id="curso" name="curso" required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="codigo">Código</label>
                                                    <input type="text" className="form-control" placeholder="Código" id="codigo" name="codigo" pattern="^[a-zA-Z0-9]+$" title="Somente letras e números" required />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="cargaHoraria">Carga Horária</label>
                                                    <input type="number" className="form-control" placeholder="Carga Horária" id="cargaHoraria" name="cargaHoraria" required />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="CR">CR</label>
                                                    <input type="text" className="form-control" placeholder="CR" id="CR" name="CR" defaultValue={this.state.cr} required disabled/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="unidade">Unidade</label>
                                                    <input type="text" className="form-control" placeholder="Unidade" id="unidade" name="unidade" required defaultValue={utils.parseUnidadeSigla(this.props.location.unidade)} disabled/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="update ml-auto mr-auto">
                                                <button type="submit" className="btn btn-primary btn-round">Cadastrar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }


}